<template>
  <div class="content forumList">
    <div class="header">发布广告</div>
    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">板块：</div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content">
          <template>
            <el-select v-model="plateClass" placeholder="请选择" size="small">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">标题：</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-input v-model="title" placeholder="请输入标题" size="small"></el-input>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">排序：</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-input v-model="sort" placeholder="请输入数字" size="small"></el-input>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">广告图：</div>
      </el-col>
      <el-col :span="18">
        <div class="grid-content">
          <el-upload
            ref="upload"
            list-type="picture-card"
            action="#"
            :http-request="(file)=> { return productUploadImg(file) }"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :file-list="fileListData"
            :limit="3"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">内容：</div>
      </el-col>
      <el-col :span="18">
        <div class="grid-content">
          <EditorBar :isClear="isClear" @change="changeeditor" v-model="dataArray"></EditorBar>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">广告地址：</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-input v-model="title" placeholder="请输入内容" size="small"></el-input>
          </template>
        </div>
      </el-col>
    </el-row>
    <!-- <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">置顶：</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-radio v-model="placedTop" label="1">是</el-radio>
            <el-radio v-model="placedTop" label="2">否</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">精华：</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-radio v-model="essence" label="1">是</el-radio>
            <el-radio v-model="essence" label="2">否</el-radio>
          </template>
        </div>
      </el-col>
    </el-row> -->

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">商品位置：</div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content">
          <template>
            <el-radio v-model="GoodsLocation" label="1">顶部</el-radio>
            <el-radio v-model="GoodsLocation" label="2">底部</el-radio>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10">
      <el-col :span="2">
        <div class="grid-content align_right">选择商品：</div>
      </el-col>
      <el-col :span="5">
        <div class="grid-content">
          <template>
            <el-select v-model="value" placeholder="请选择" size="small">
              <el-option
                v-for="item in commodityList"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </template>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="issue">
      <el-col :span="5" :offset="2">
        <div class="grid-content">
          <el-button size="small" type="primary" @click="issue">发布</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getComList, addImage } from "@/api/mall";
import EditorBar from "@Components/public/wangEnduit";
import { mapGetters } from "vuex";
export default {
  components: {
    EditorBar
  },
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data() {
    return {
      imgdata: {},
      imageUrl: "",
      imageIdx: 0,
      fileListData:[], //filelist列表
      dialogImageUrl: "", // 上传商品图片
      dialogVisible: false,
      chosepictireid:[], //已上传图片id数组暂存
      plateClass: "", // 板块名
      options: [
        {
          value: "招聘",
          label: "招聘"
        },
        {
          value: "新闻",
          label: "新闻"
        },
        {
          value: "美食",
          label: "美食"
        }
      ],
      title: "",
      sort: "",
      // 编辑器
      isClear: false,
      detail: "", // 内容
      placedTop: 0, //置顶
      essence: 0, // 精华
      GoodsLocation: 0, // 商品位置
      input: "",
      dataArray: "",
      listData: [], //列表
      commodityList: "",
      value: "" // 选择商品
    };
  },
  mounted() {
    this.getcomLists();
  },
  methods: {
    // 商品图片
    handleRemove(file) {
      //  图片删除同步更改列表
      var replaceArr = this.fakefileList;
      for(var i= 0; i < replaceArr.length; i++){
        if(file.uid == replaceArr[i].uid){
          replaceArr.splice(i,1);
          this.chosepictireid.splice(i,1);
          this.dataArray.goods.image_id = this.chosepictireid.join(',');
          console.log(this.dataArray.goods.image_id,"dffffffff");
          break;
        }
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
    },
    // 图片
    productUploadImg(file){
      var that = this;
      var formdata = new FormData();
      formdata.append('token', that.token);
      formdata.append('image', file.file);
      formdata.append('type', "1");
      formdata.append('file_group', "1");
      addImage(formdata).then(res => {
        console.log("上传回调",res);
        var data = res.data;
        if(res.code == 200){
          this.chosepictireid.push(res.data.id);
          this.dataArray.goods.image_id = this.chosepictireid.join(',');
          var list = {};
          var index = 0;
          list.name = res.data.key;
          list.url = res.data.url;
          // 图片列表
          this.fakefileList.push(list);
        } else{
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 编辑器
    changeeditor(val) {
      this.detail = val;
      console.log(val, this.dataArray);
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getcomLists(idx = 0) {
      const statusArr = [
        {
          token: this.token,
          app_id: this.app_id,
          page: this.page
        },
        {
          token: this.token,
          app_id: this.app_id,
          page: this.page,
          limit: 10,
          marketable: 1
        },
        {
          token: this.token,
          app_id: this.app_id,
          page: this.page,
          limit: 10,
          stock: 1
        },
        {
          token: this.token,
          app_id: this.app_id,
          page: this.page,
          limit: 10,
          marketable: 2
        }
      ];
      this.commodityList = [];
      getComList(statusArr[idx]).then(res => {
        console.log(res);
        if (res.code == 200) {
          if (res.data.length > 0) {
            setTimeout(() => {
              this.commodityList = res.data;
            }, 400);
          }
        }
      });
    },
    // 假发帖步骤
    issue() {
      let data = {
        title: this.title,
        sort: this.sort,
        // 编辑器
        GoodsLocation: this.GoodsLocation, // 商品位置
        imageUrl: this.imageUrl, //图片地址
        detail: this.detail,
        plateClass: this.plateClass,
        infor: {
          share: 0,
          like: 0,
          browse: 0
        },
        time: "2020-01-14",
        name: "回家",
        state: {
          placedTop: this.placedTop,
          essence: this.essence
        }
      };
      if (localStorage.getItem("forumList") == null) {
        localStorage.setItem("forumList", JSON.stringify([data]));
      } else {
        console.log(localStorage.getItem("forumList"));
        let localData = JSON.parse(localStorage.getItem("forumList"));
        localData.push(data);
        localStorage.setItem("forumList", JSON.stringify(localData));
      }
      this.$router.push({
        path: "/apply/forum/18/forumList"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
}
.forumList {
  padding: 10px 25px;
  .header {
    border-bottom: 0;
    background-color: #f8f8f8;
    position: relative;
    padding-left: 24px;
    margin-bottom: 15px;
    padding: 10px 15px;
  }
  .header:after {
    content: "";
    position: absolute;
    width: 4px;
    height: 16px;
    background: #1ab394;
    border-radius: 30%;
    top: 50%;
    left: 10px;
    margin-top: -8px;
  }
  .grid-content {
    min-width: 80px;
    min-height: 32px;
    line-height: 32px;
  }
  .align_right {
    text-align: right;
    font-size: 14px;
  }
  .hint {
    padding: 10px 0;
    color: #909399;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .issue {
    padding: 10px 0 30px;
  }
}
</style>

<style lang="scss">
.forumList {
  .editor {
    width: 100%;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>